@if (loadingOverlay.visible()) {
  <div class="loading-overlay">
    <div class="loading-backdrop"></div>

    <div class="loading-content">
      <mat-spinner diameter="75"></mat-spinner>
    </div>
  </div>
}